import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
const PinLogin = () => {
    const [pin, setPin] = useState('');
    const [error, setError] = useState(false);
    const navigate = useNavigate();
    const correctPin = '20890'; // Example correct PIN

    useEffect(() => {
        if (pin.length === 5) {
            handleSubmit();
        }
        // eslint-disable-next-line 
    }, [pin]);

    const handleNumberClick = (num) => {
        if (pin.length < 5) setPin(pin + num);
    };

    const handleBackspace = () => {
        setPin(pin.slice(0, -1));
    };

    const handleSubmit = () => {
        if (pin === correctPin) {
            navigate('/pay');
        } else {
            setError(true); // Show error (e.g., red dots or shake)
            setTimeout(() => {
                setPin('');
                setError(false);
                window.location.reload();

            }, 500); // Wait a bit so user sees the error state
        }
    };
    useEffect(() => {
        if (pin.length === 5) {
            handleSubmit();
        }

        const handleKeyDown = (e) => {
            if (e.key >= '0' && e.key <= '9') {
                handleNumberClick(e.key);
            } else if (e.key === 'Backspace' || e.key === 'Delete' || e.key === '.') {
                handleBackspace();
            } else if (e.key === 'Enter') {
                handleSubmit();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
        // eslint-disable-next-line 
    }, [pin]);


    return (
        <div className="ltr-direction min-h-screen w-screen   bg-gray-900 text-white flex flex-col items-center justify-between py-6">
            <div className="text-center">
                {/* <h1 className="text-4xl font-bold mb-2">paysera</h1> */}
                <div

                    className="flex flex-col items-center  mb-8 cursor-pointer   text-gray-400 text-xs  rounded-lg transition"
                >
                    <img
                        src="/paysera/login.png"
                        alt="logo"
                        className="w-41 h-11"
                    />
                </div>
                <p className="text-sm mb-3">ENTER PIN CODE</p>
                <div className="flex justify-center space-x-3 mb-6">
                    {[...Array(5)].map((_, i) => (
                        <div
                            key={i}
                            className={`w-3 h-3 rounded-full border-2 ${i < pin.length ? 'bg-white' : 'border-white'
                                } ${error ? 'border-red-500' : ''}`}
                        />
                    ))}
                </div>
            </div>

            <div className="grid grid-cols-3 gap-4 w-64 text-xl">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                    <button
                        key={num}
                        onClick={() => handleNumberClick(num.toString())}
                        className="p-4 bg-gray-700 rounded-full"
                    >
                        {num}
                    </button>
                ))}
                <button onClick={handleSubmit} className="p-4 bg-gray-700 rounded-full">↩</button>
                <button onClick={() => handleNumberClick('0')} className="p-4 bg-gray-700 rounded-full">0</button>
                <button onClick={handleBackspace} className="p-4 bg-gray-700 rounded-full">⌫</button>
            </div>

            <div className="flex flex-col items-center  cursor-pointer mt-2 " >
                <img
                    src="/paysera/finger.png"
                    alt="logo"
                    className="w-28 h-22"
                />
            </div>
            <p className="text-sm mt-3 underline text-gray-400">Forgot your PIN code?</p>
        </div>
    );
};

export default PinLogin;
